import { useParams } from "react-router-dom";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../hooks/useTypedSelector";
import { useTranslation } from "react-i18next";
import React, { useEffect } from "react";
import {
  Layout,
  LayoutContent,
  LayoutHeader,
  LayoutHeaderTitle,
} from "../../../general/modules/commons/layout/layout";
import { logout } from "../../../auth/infrastructure/slices/authSlice/authSlice";
import {
  Breadcrumb,
  BreadCrumbItem,
} from "../../../general/modules/commons/breadcrumb/breadcrumb";
import RequestMutateForm from "../features/requestMutateForm";
import {
  getTireset,
  clear,
  setLoading,
} from "../../../tireset/infrastructure/slices/tireSetMutateSlice";
import LicensePlate from "license-plate";
import { Content } from "../../../general/modules/commons/content/content";
import { ContentHeader } from "../../../general/modules/commons/content/contentHeader";
import { useAuthorization } from "../../../../hooks/useAuthorization";

export const RequestCreatePage = () => {
  const { tiresetId } = useParams();
  const { hasRole } = useAuthorization();

  if (!tiresetId) {
    return <></>;
  }

  const dispatch = useAppDispatch();

  const { t } = useTranslation("common");

  const { loading, tireset } = useAppSelector((state) => state.tiresetMutate);

  useEffect(() => {
    if (tiresetId !== undefined) {
      void dispatch(getTireset(tiresetId));
    } else {
      dispatch(setLoading(false));
    }

    return () => {
      dispatch(clear());
    };
  }, [tiresetId]);

  const title = t("Request");

  const licensePlate = tireset?.car?.licence
    ? new LicensePlate(tireset?.car?.licence).pretty()
    : "";

  if (
    hasRole("dbh-employee") ||
    hasRole("dbh-driver") ||
    hasRole("dbh-order-picker")
  ) {
    return (
      <Layout>
        <LayoutContent>
          <Content>
            <ContentHeader className={"mt-3"} title={t("Access denied")} />
            <p className={"mt-3"}>{t("You don't have access to this page")}</p>
          </Content>
        </LayoutContent>
      </Layout>
    );
  }

  return (
    <Layout
      header={
        <LayoutHeader logout={() => void dispatch(logout())}>
          <LayoutHeaderTitle title={title} loading={loading} />
          <Breadcrumb>
            <BreadCrumbItem to="/tire-sets">{t(`Tire sets`)}</BreadCrumbItem>
            {(tireset?.car?.id ?? false) && (
              <BreadCrumbItem to={`/car/${tireset?.car?.id}/edit`}>
                {licensePlate ?? ""} {tireset?.car?.label}
              </BreadCrumbItem>
            )}
            <BreadCrumbItem>{t(`Request`)}</BreadCrumbItem>
          </Breadcrumb>
        </LayoutHeader>
      }
    >
      {!loading && (
        <RequestMutateForm
          key={null}
          submitButtonLabel={t("request.save_and_submit")}
        />
      )}
    </Layout>
  );
};
